"use client";
import { ThemeProvider } from "@mui/material/styles";
import { Box, CssBaseline } from "@mui/material";
import { ReactNode, useEffect, useState } from "react";
import { theme } from "@/styles/theme";

export function MuiThemeProvider({ children }: { children: ReactNode }) {
	const [isMounted, setIsMounted] = useState(false);

	useEffect(() => {
		setIsMounted(true);
	}, []);

	if (!isMounted) {
		return null;
	}

	return (
		<ThemeProvider theme={theme}>
			<CssBaseline enableColorScheme />
			<Box
				sx={{
					// bgcolor: "background.default", // Убрал, чтобы был виден градиент body
					display: "flex",
					flexDirection: "column",
					minHeight: "100vh",
					color: "text.primary",
				}}
			>
				{children}
			</Box>
		</ThemeProvider>
	);
}
